import React from "react"
import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { browserHistory } from "react-router"
import { ONGOING_DELIVERIES_ERROR_MESSAGE } from "../../../actions/Organizations/Enterprise"

const sx = {
  dialog: {
    "& .MuiDialog-paper": {
      width: 560,
      maxWidth: "calc(100vw - 32px)",
      borderRadius: "12px",
      boxShadow: "0 12px 40px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)",
    },
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 2,
    p: "32px 40px 8px",
  },
  title: {
    fontSize: 20,
    fontWeight: 400,
    color: "#F44559",
    lineHeight: 1.3,
  },
  closeBtn: {
    width: 36,
    height: 36,
    color: "#555555",
    "&:hover": { bgcolor: "#F0F0F0" },
  },
  body: {
    p: "24px 40px 8px",
    fontSize: 16,
    color: "#414141",
    lineHeight: 1.55,
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 1,
    p: "24px 40px 32px",
  },
  btnText: {
    color: "#2196F3",
    fontSize: 14,
    fontWeight: 500,
    px: "28px",
    py: "12px",
    borderRadius: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    "&:hover": { bgcolor: "#E3F2FD" },
  },
  btnFilled: {
    bgcolor: "#2196F3",
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: 500,
    px: "28px",
    py: "12px",
    borderRadius: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    boxShadow: "0 2px 4px rgba(33,150,243,0.3)",
    "&:hover": {
      bgcolor: "#2196F3",
      boxShadow: "0 4px 8px rgba(33,150,243,0.4)",
    },
  },
}

const ArchiveEnterpriseBlockedModal = ({ open, onClose, reason }) => {
  const isPlanningRules = reason === "planningRules"

  const handleGoToPlanning = () => {
    onClose()
    browserHistory.push("/settings/production/reports")
  }

  return (
    <Dialog open={open} onClose={onClose} sx={sx.dialog}>
      <Box sx={sx.header}>
        <Typography sx={sx.title}>Archivage impossible</Typography>
        <IconButton onClick={onClose} sx={sx.closeBtn} aria-label="Fermer">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Typography role="alert" component="div" sx={sx.body}>
        {isPlanningRules
          ? "Cette entreprise est référencée dans les règles de reports planning. Retirez-la des règles concernées avant de pouvoir l'archiver."
          : ONGOING_DELIVERIES_ERROR_MESSAGE
        }
      </Typography>

      <Box sx={sx.footer}>
        {isPlanningRules ? (
          <>
            <Button sx={sx.btnText} onClick={onClose}>Annuler</Button>
            <Button sx={sx.btnFilled} onClick={handleGoToPlanning}>
              Voir les règles de planning
            </Button>
          </>
        ) : (
          <Button sx={sx.btnFilled} onClick={onClose}>Fermer</Button>
        )}
      </Box>
    </Dialog>
  )
}

export default ArchiveEnterpriseBlockedModal
